<template>
  <div class="youtube-wrap">
    <div class="header"><span>YouTube批量上传工具</span></div>
    <div class="container">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="YouTube视频" name="video">
          <youtube-video v-if="activeName === 'video'"></youtube-video>
        </el-tab-pane>
        <el-tab-pane label="YouTube频道" name="channel">
          <youtube-channel v-if="activeName === 'channel'"></youtube-channel>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import YoutubeVideo from "./components/YoutubeVideo";
import YoutubeChannel from "./components/YoutubeChannel";

export default {
  components: {
    YoutubeVideo,
    YoutubeChannel,
  },

  data() {
    return {
      activeName: "video",
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.youtube-wrap {
  border-radius: 4px;
  margin: 16px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
  height: calc(~"100% - 38px");
  background: #ffffff;
  .header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: rgba(24, 144, 255, 1);
    padding-left: 25px;
  }
  .container {
    height: calc(~"100% - 104px");
    padding: 16px 24px;
  }
}
</style>
